// extracted by mini-css-extract-plugin
export default {"searchContainer":"SearchInput__searchContainer___iLOpZ"};